





























import VueSlider from 'vue-slider-component'
import { formatRecordingTime } from '@/util'
import Vue from 'vue'

type DataType = { value: number }

export default Vue.extend({
  name: 'VideoSliderBar',
  components: {
    VueSlider,
  },
  props: {
    elapsedTime: {
      type: Number,
      default: 0,
    },
    totalTime: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data(): DataType {
    return { value: 0 }
  },
  computed: {
    playbackPosition: function (): string {
      // prettier-ignore
      return `${formatRecordingTime(this.elapsedTime)}/${formatRecordingTime(this.totalTime)}`
    },
  },
  methods: {
    tooltipFormatter: function (value: number): string {
      return formatRecordingTime(value)
    },
    change: function (time: number): void {
      this.$emit('change', time)
    },
  },
  watch: {
    elapsedTime: function (newElapsedTime: number): void {
      this.value = newElapsedTime
    },
  },
})
